import React, { useCallback, useMemo } from 'react';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToFountainStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WriteBackToFountainMergeAuthMethod } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WriteBackToFountainPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WorkflowDataSetSelector } from 'apps/sigma2-ui/src/components/workflows/WorkflowDataSetSelector';
import { ConfigureWriteBackFountainPlaceToWrite } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackFountainPlaceToWrite';
import { isMergeAtsIntegrationDataSet } from 'libs/end-to-end/src/is-merge-ats-integration-data-set';

export interface ConfigureWriteBackFountainStrategyProps
  extends ConfigureWorkflowBaseProps {
  strategy: WriteBackToFountainStrategy | null;

  updateStrategy: (strategy: WriteBackToFountainStrategy | null) => void;

  allowedPlacesToWriteTypes: WriteBackToFountainPlaceToWrite['type'][];
}

export const ConfigureWriteBackFountainStrategy = ({
  strategy,
  updateStrategy,
  listSecretsPattern,
  organizationId,
  listDataSetsPattern,
  allowedPlacesToWriteTypes,
}: ConfigureWriteBackFountainStrategyProps) => {
  const updateAuthMethod = useCallback(
    (authMethod: WriteBackToFountainMergeAuthMethod | null) => {
      updateStrategy({
        type: 'fountain',
        ...strategy,
        authMethod: authMethod ?? undefined,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedAuthMethod = useMemo(
    () => strategy?.authMethod ?? null,
    [strategy?.authMethod],
  );

  const updatePlacesToWrite = useCallback(
    (placesToWrite: WriteBackToFountainPlaceToWrite[]) => {
      updateStrategy({
        type: 'fountain',
        ...strategy,
        placesToWrite,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedPlacesToWrite = useMemo(
    () => strategy?.placesToWrite ?? [],
    [strategy?.placesToWrite],
  );

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-xl font-semibold">Configure Fountain Strategy</h2>
      <p className="text-gray-600">
        Configure the strategy for writing back the hiring readiness score to
        Fountain.
      </p>
      <WorkflowDataSetSelector
        dataSetId={selectedAuthMethod?.dataSetId ?? null}
        title="Select a merge ATS data set"
        listDataSetsPattern={listDataSetsPattern}
        setDataSetId={(dataSetId) => {
          updateAuthMethod({
            type: 'merge',
            dataSetId: dataSetId ?? undefined,
          });
        }}
        filterFn={isMergeAtsIntegrationDataSet}
      />
      <ConfigureWriteBackFountainPlaceToWrite
        placesToWrite={selectedPlacesToWrite}
        updatePlacesToWrite={updatePlacesToWrite}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
        allowedPlacesToWriteTypes={allowedPlacesToWriteTypes}
      />
    </div>
  );
};
